import { render } from "./DeclinedFinal.vue?vue&type=template&id=22d662da"
import script from "./DeclinedFinal.vue?vue&type=script&lang=js"
export * from "./DeclinedFinal.vue?vue&type=script&lang=js"

import "./DeclinedFinal.vue?vue&type=style&index=0&id=22d662da&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__